import {setScreen} from '../../services/router';
import VerifyEmail from './VerifyEmail/VerifyEmail';

export default function AuthVerifyEmailPage() {
  return <VerifyEmail />;
}
